var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    {
      staticClass: "box",
      attrs: {
        "align-center": "",
        "justify-start": "",
        column: "",
        "fill-height": ""
      }
    },
    [
      _c(
        "v-layout",
        { attrs: { row: "" } },
        [
          _c("Autocomplete", {
            attrs: {
              label: this.label,
              results: _vm.list,
              preloader: _vm.preloader,
              labels: ["first_name", "last_name"],
              separators: [" ", " "]
            },
            on: { search: _vm.search, select: _vm.select, clear: _vm.clear }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-layout",
        { staticClass: "transfer-wallet" },
        [
          _vm.selected.wallet.id
            ? _c("Wallet", {
                attrs: {
                  walletId: this.selected.wallet.id,
                  withDraw: false,
                  owner: this.selected
                }
              })
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-33e35258", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-33e35258","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Transfers/NewTransfer/Wallet.vue
// module id = null
// module chunks = 